export default {
      id: "sensor__address-usage",
      viewBox: "0 0 33 46",
      url: __webpack_public_path__ + "img/icons.svg#sensor__address",
      toString: function () {
        return this.url;
      }
    }